import { RequestHelper } from "../Helpers/RequestHelper.js";
import { DataDriver } from "../Drivers/DataDriver.js";

export class PixelmotionDriver extends DataDriver {
    constructor(pmdrs) {
        super(pmdrs);
        this.key = DataDriver.PIXELMOTION_KEY;
        this.themeClass = "pm-theme";
        this.balloonCashMode = false;//false uses balloon rates, true uses balloonCash rates
    }

    pullApiConfig(successCallback, errorCallback) {
        let driver = this;
        let pmdrs = this.pmdrs;
        //SUCCESS
        let sc = (response) => {
            if (response) {
                driver.apr = JSON.parse(response);
                driver.getInitialPaymentFromApi(successCallback, errorCallback);
                // console.log(driver.apr);
                // if (successCallback) {
                //     successCallback();
                // }
            } else {
                console.error("Error getting APR: empty response");
            }
        };

        //ERROR
        let ec = () => {
            console.error("Error getting OfferlogixDriver config");
            if (errorCallback) {
                errorCallback();
            }
        };

        //get APR from pm-drs-api
        pmdrs.pmApi.getPixelmotionAPR(
            pmdrs.config.oem,
            pmdrs.config.accountId,
            pmdrs.frontApp.config.vehicle.vin || "all",
            sc,
            ec
        );
    }

    setInitialPayments(initialPayments){
        this.initialPayments = initialPayments;
        if(this.initialPayments.balloon?.balloonType == 'easyridecash'){
            this.balloonCashMode = true;
        }
    }    
        
    getInitialPayment(type, successCallback, errorCallback){
        var payment = this.initialPayments[type];                
        if(!payment){//IF NO PAYMENTS
            successCallback(null);
            return;
        }
        let paymentObject = this.formatApiPayment(payment);
        successCallback(paymentObject);
    }

    getInitialPaymentFromApi(successCallback, errorCallback){
        let driver = this;
        let pmdrs = this.pmdrs;
        let vin = pmdrs.frontApp.config.vehicle.vin;

         //SUCCESS
         let sc = (response) => {
            var pmPaymentsByVin = JSON.parse(response);
            var initialPayments = pmPaymentsByVin[vin];
            if(!initialPayments) {
                console.info("No pm payments available for: " + vin);
                return;//skip if not enabled
            }
            driver.setInitialPayments(initialPayments);
            console.log(initialPayments);

            if (successCallback) {
                successCallback();
            }
        };

        //ERROR
        let ec = () => {
            console.error("Error getting initial Pm Payment");
            if (errorCallback) {
                errorCallback();
            }
        };

        //get APR from pm-drs-api
         pmdrs.pmApi.getPmPaymentsBySite(
            pmdrs.config.accountId,
            {vins: [vin]},            
            sc,
            ec
        );
    }

     //maps to pm-drs format standard, check example in PixelmotionDriver.js
     formatApiPayment(apiPayment){
        var disclaimerText = apiPayment.disclaimer
        if(disclaimerText){
            disclaimerText = disclaimerText
            .replaceAll("{dealerName}", this.pmdrs.config.dealerName)
            .replaceAll("{dealerPhone}", this.pmdrs.config.dealerPhone);
        }

        let paymentObject = this.formatPaymentObject({
            dealType: apiPayment.dealType,
            moneyFactor: apiPayment.apr,
            monthlyPayment: apiPayment.monthlyPayment,
            // totalPayments: apiPayment.totalPayments,
            downPayment: apiPayment.downPayment,
            term: apiPayment.term,
            // expirationDate: apiPayment.expirationDate,
            disclaimerText: disclaimerText,
            // conditionalOffers: this._formatRebates(apiPayment),//PMDRS will call it conditionalOffers
            // lenderId: apiPayment.lenderId,
            creditRating: apiPayment.creditScore,
            purchasePrice: apiPayment.finalPrice,
            balloonPayment: apiPayment.balloonPayment,
            balloonType: apiPayment.balloonType,
            customerCash: apiPayment.bmwCustomerCash || 0,
            payment: apiPayment.payment ?? 0,
            financedAmount: apiPayment.financedAmount,
            docFeeForTotal: apiPayment.docFeeForTotal,
            docFeeDisplay: apiPayment.docFeeDisplay,
            cashDownDisplay: apiPayment.cashDownDisplay,
            netPriceDisplay: apiPayment.netPriceDisplay,
            finalPriceDisplay: apiPayment.finalPriceDisplay,
            isValid: apiPayment.isValid,
            dueAtSignBase: apiPayment.dueAtSignBase,
            dueAtSignWithTaxes: apiPayment.dueAtSignWithTaxes,
        });

        // if(apiPayment.feesAndTaxes){
        //     paymentObject.feesAndTaxesTotal = apiPayment.feesAndTaxes.feeTotal;
        //     paymentObject.feesAndTaxesList = this._formatFeesAndTaxesList(apiPayment.feesAndTaxes);
        // }

        paymentObject.dueAtSign = apiPayment.downPayment || 0;

        return paymentObject;
    }

    getPayment(taxes, type, paymentData, successCallback, errorCallback) {
        var pmdrs = this.pmdrs;
        var vehicle = pmdrs.frontApp.config.vehicle;      
        var tradeInValue = parseFloat(paymentData.tradeInData.tradeInEstimate);
        var downPayment = parseFloat(paymentData.cashDown);
        let accessoriesTotal = paymentData.accessoriesPrice;
        let incentivesTotal = paymentData.totalIncentives ?? 0;

        const isBMW = vehicle.make.toLowerCase() === 'bmw';
        const useMSRPForCalc = pmdrs.frontApp.siteSettings.useMSRPForCalculations;

        // #69082 — client wants the lowest payment shown for this unit
        const normalizedModel = (vehicle.model || '').replace(/\s+/g, '').toUpperCase();
        const isBmwmcriverside2026M1000RR = pmdrs.config.accountId === 'bmwmcriverside'
            && String(vehicle.year) === '2026'
            && normalizedModel === 'M1000RR';

        const useMSRP = !isBmwmcriverside2026M1000RR
            && ((isBMW && useMSRPForCalc !== false) || pmdrs.config.accountId === 'euroutah');
        var selliingPrice = useMSRP ? pmdrs.frontApp.getVehicleRetailPrice() : vehicle.finalPrice;
        // substract incentives if exists
        // if (paymentData.totalIncentives != undefined) {
        //     selliingPrice = selliingPrice - paymentData.totalIncentives;
        // }
        const isLease = type == "lease";
        const isFinance = type == "finance";
        const isCash = type == "cash";

        let requestParams = {
            'siteToken': pmdrs.config.accountId,
            'oem': pmdrs.getOEM(),            
            'vin': vehicle.vin,
            // 'ZipCode': pmdrs.config.dealerZipCode,
            'dealType': type, //blank to get all, Lease, Loan or Cash
            'balloonType': paymentData.balloonType, //created for easyridecash, special case
            // 'Miles': vehicle.mileage,//odometer            
            // 'SellingPrice': selliingPrice,//SellingPrice is the api/payments endpoint
            'finalPrice': selliingPrice,
            'msrp': pmdrs.frontApp.getVehicleRetailPrice(),
            // 'AnnualMileage': paymentData.mileageAllowance, //Number of miles which must not be exceeded during the course of the lease agreement.             
            // US-130 is Chrysler Capital, asked to Brad
            // US-169 is Stellantis Financial Services, asked to Brad. 
            // They both provide incentives in rebates or conditionalRebates, we're trying to use them  
            // 'Lenders': lenders,//List of IDs of lenders to be used. Only payments related to this lenders will be retrieved. To know the possible values for the lender IDs, check the Lenders GET operation. Cash blank to get payments related to any lender.
            // 'IncludeCustomDisclosures': "true",//default is false,
            "creditScore": paymentData.creditRating, //required for all types
            "tradeInAmount": tradeInValue,
            "accessoriesTotal": accessoriesTotal,
            "incentivesTotal": incentivesTotal,
            "taxesByZipCode": paymentData.taxesByZipCode,
            // "useBalloonCashMode": (this.balloonCashMode || type == "cash") ? '1' : '0',

        };

        const draFees = pmdrs.frontApp.getDraFees();
        if (draFees !== null) requestParams['draFees'] = JSON.stringify(draFees);

        console.log(requestParams);

        if (!isCash) {
            requestParams["term"] = paymentData.loanMonths;
            requestParams["downPayment"] = downPayment;
        }

        let sc = (response) => {
            console.log(response);
            const payment = JSON.parse(response);
            if(!payment){//IF NO PAYMENTS
                successCallback(null);
                return;
            }
            
            let paymentObject = this.formatApiPayment(payment);        
            successCallback(paymentObject);
        };

        //ERROR
        let ec = () => {
            console.error("Error getting Pm Payment");
            if (errorCallback) {
                errorCallback();
            }
        };

        //get APR from pm-drs-api
         pmdrs.pmApi.getPmPayments(
            requestParams,            
            sc,
            ec
        );
    }


    /**
     * [getCSRIncentives description]
     * @param  {String} dealType        finance lease or cash
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getCSRIncentives(dealType, successCallback, errorCallback) {
        let pmdrs = this.pmdrs;

        let csrDealType = "";
        switch (dealType) {
            case "lease":
                csrDealType = "manufacturer_lease_special";
            default:
                csrDealType = "manufacturer_special_apr";
        }

        let requestParams = {
            vin: pmdrs.frontApp.config.vehicle.vin,
            postalCode: pmdrs.config.dealerZipCode,
            dealType: csrDealType,
        };

        pmdrs.pmApi.findVehicleGroups(requestParams, successCallback, errorCallback);
    }

    getCreditRanges(dealType, mpy) {
        let pmdrs = this.pmdrs;
        let ranges = {};
        let oem = pmdrs.getOEM();
        switch (dealType) {
            case "finance":
                return this.apr.finance.creditScore;

            case "balloon":
            case "premier":
            case "ttf":
                return this.apr.balloon.creditScore;

            case "lease":
                for (let i = 0; i < this.apr.lease.length; i++) {
                    let apr = this.apr.lease[i];
                    if (mpy == null) return this.addCustomizedCreditScore(apr, i);
                    if (apr.mpy == mpy) return this.addCustomizedCreditScore(apr, i);
                }
        }
        return null;
    }

    addCustomizedCreditScore(apr, i) {
        let ranges = { ...this.apr.range_config };
        if (apr.hasOwnProperty("creditScore")) {
            Object.keys(apr.creditScore).forEach((credit) => {
                ranges[credit] = {
                    label: this.apr.lease[i].creditScore[credit].label,
                    min: this.apr.lease[i].creditScore[credit].min,
                    max: this.apr.lease[i].creditScore[credit].max,
                };
            });
            return ranges;
        }
        return this.apr.range_config;
    }
}
